<i class="bento-icon-envelope"></i>
<div class="client-information-info">
	<div class="no-entries" *ngIf="emailAddresses?.length === 0">
		<span class="client-information-header-truncate" data-qe-id="client-dashboard-email-none"
			[translate]="'Bluemoon.Core.ClientDashboard.None'">
		</span>
	</div>
	<div *ngIf="emailAddresses?.length > 0">
		<span class="no-margin-b client-information-header-truncate">
			<a role="button" href="mailto:{{primaryEmailAddress?.emailAddress}}">
				<div data-qe-id="client-dashboard-client-widget-primary-email">
					{{primaryEmailAddress?.emailAddress}}
				</div>
			</a>
		</span>
		<span data-qe-id="client-dashboard-primary-email-type-name" class="panel-time no-margin">
			{{formatPrimaryString(primaryEmailAddress?.emailType?.name)}}
		</span>
	</div>

	<div *ngFor="let emailAddress of otherEmailAddresses; let i = index;">
		<span class="no-margin-b client-information-header-truncate">
			<a role="button" href="mailto:{{emailAddress?.emailAddress}}">
				<div attr.data-qe-id="client-dashboard-client-widget-other-email-{{i}}">
					{{emailAddress?.emailAddress}}
				</div>
			</a>
		</span>
		<span data-qe-id="client-dashboard-email-type-name" class="panel-time no-margin">
			{{emailAddress?.emailType?.name}}
		</span>
	</div>
</div>
